import React, { Component } from 'react';
import moment from 'moment';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import { TableWrapper, TableContainer, Table, StatusContainer } from './styled';
import { CSVLink } from 'react-csv';
import Loading from '../../../../components/Loading';

class Promotions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvData: [],
      coupons: [],
      loading: false,
    };

    this.downloadPromotions = this.downloadPromotions.bind(this);
  }

  componentDidMount() {
    if (this.props.userInfo.publisher) {
      this.retrieveCoupons(this.props.userInfo.publisher.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.userInfo.publisher &&
      nextProps.userInfo.publisher !== this.props.userInfo.publisher
    ) {
      this.retrieveCoupons(nextProps.userInfo.publisher.id);
    }
  }

  downloadPromotions(e) {
    e.preventDefault();
    const { userInfo } = this.props;
    window.location.href = `/api/coupon_csvexport/${userInfo.publisher.id}`;
  }

  retrieveCoupons(publisherId) {
    this.setState({ loading: true }, () => {
      Axios.get('/api/coupon', {
        params: { filter: { publisherId: publisherId } },
      })
        .then(res => {
          const csvData = [['Date', 'Coupon Code', 'Soundcast Title']];

          if (res.data && res.data.length) {
            res.data.forEach(coupon => {
              csvData.push([
                moment.unix(Number(coupon.timeStamp)).format('YYYY-MM-DD'),
                coupon.coupon,
                coupon.soundcastTitle,
              ]);
            });
          }

          this.setState({
            coupons: res.data,
            csvData,
            loading: false,
          });
        })
        .catch(err => {
          console.log('error retrieving: ', err);
          this.setState({ loading: false });
        });
    });
  }

  renderBody() {
    const { coupons = [], loading, csvData } = this.state;
    const { userInfo = {} } = this.props;

    if (!('publisher' in userInfo) || loading) {
      return (
        <div className="row">
          <div className="col-md-12">
            <StatusContainer>
              <Loading text="Loading promotions" align="center" />
            </StatusContainer>
          </div>
        </div>
      );
    }

    if (isEmpty(coupons)) {
      return (
        <div className="row">
          <div className="col-md-12">
            <StatusContainer className="title-small padding-40px-tb">
              <span>There are no promotions to show.</span>
            </StatusContainer>
          </div>
        </div>
      );
    }

    return (
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="table-wrapper table-responsive">
            <PromotionsHeader>
              <DownloadPromotions onClick={this.downloadPromotions}>
                <i className="material-icons">
                  cloud_download
                </i>
                <CSVLink
                  data={csvData}
                  filename={`Promocode Usage ${moment().format('YYYY-MM-DD')}.csv`}
                >
                  <span className="text-medium font-weight-600 hidden-xs">Download Promocode Usage</span>
                </CSVLink>
              </DownloadPromotions>
            </PromotionsHeader>
            <TableContainer>
              <Table className="table table-hover">
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th>COUPON CODE</th>
                    <th>SOUNDCAST TITLE</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {coupons.map((coupon, i) => {
                    return (
                      <tr key={i}>
                        <td className="padding-top-20px padding-bottom-20px">
                          {moment.unix(Number(coupon.timeStamp)).format('YYYY-MM-DD')}
                        </td>
                        <td className="padding-top-20px padding-bottom-20px">{coupon.coupon}</td>
                        <td className="padding-top-20px padding-bottom-20px">
                          {coupon.soundcastTitle}
                        </td>
                        <td></td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { userInfo } = this.props;
    return <TableWrapper>{this.renderBody()}</TableWrapper>;
  }
}

const PromotionsHeader = styled.div`
  background: #fff;
  padding: 20px 24px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  border-bottom: 1px solid #eee;
  margin-top: 25px;
`;


const DownloadPromotions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  i, span {
    color: #646464;
    margin-right: 5px;
  }

  &:hover {
    i {
      color: #1f1f1f;
    }
  }
`;

export default Promotions;
